import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home.js";
import "./index.css";
import Projects from "./Pages/Projects.js";
import SingleProject from "./Pages/SingleProject.js";
import Articles from "./Pages/Articles.js";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<SingleProject />} />
        <Route path="/articles" element={<Articles />} />
      </Routes>
    </Router>
  );
}



export default App;